import { useState } from 'react';
import { contact, monthlyPlans, projectPlans } from '../data';

function CheckList({ items }) {
  return (
    <ul className="check-list">
      {items.map((item) => (
        <li key={item}>
          <span className="check" aria-hidden="true">
            ✓
          </span>
          {item}
        </li>
      ))}
    </ul>
  );
}

const planOptions = Object.values(monthlyPlans);

export default function Pricing() {
  const [activePlan, setActivePlan] = useState('essential');
  const plan = monthlyPlans[activePlan];
  const activeIndex = planOptions.findIndex((option) => option.id === activePlan);

  return (
    <section className="section pricing" id="pricing">
      <div className="container">
        <div className="section-head" data-reveal>
          <h2 className="display-2">
            Simple pricing. <em>No surprises.</em>
          </h2>
          <p className="section-lede">
            Straightforward pricing built around the amount of work your business actually needs.
          </p>
        </div>

        <div className="pricing-grid">
          {projectPlans.map((project) => (
            <article className="price-card" key={project.id} data-reveal>
              <div className="price-card-top" aria-hidden="true" />
              <p className="plan-name">{project.name}</p>
              <p className="plan-price">
                <span className={project.priceLead ? 'price-lead' : 'price-lead is-placeholder'}>
                  {project.priceLead || 'Starting at'}
                </span>
                <span className="price-figure">{project.price}</span>
                <span className="price-unit">{project.unit}</span>
              </p>
              <p className="plan-copy">{project.copy}</p>
              <a
                className="btn btn-soft btn-block"
                href={contact.schedulingHref}
                target="_blank"
                rel="noopener noreferrer"
              >
                Get Started
              </a>
              <div className="price-card-footer">
                <p className="includes-label">Included:</p>
                <CheckList items={project.items} />
                {project.note && <p className="fine-print">{project.note}</p>}
              </div>
            </article>
          ))}

          <article className="price-card is-featured" data-reveal>
            <div className="price-card-top">
              <div
                className={`plan-toggle${activePlan === 'growth' ? ' is-growth' : ''}`}
                role="group"
                aria-label="Choose a monthly bookkeeping plan"
              >
                <span
                  className="plan-toggle-thumb"
                  aria-hidden="true"
                  style={{ transform: `translateX(${activeIndex * 100}%)` }}
                />
                {planOptions.map((option) => (
                  <button
                    type="button"
                    key={option.id}
                    className={activePlan === option.id ? 'is-active' : ''}
                    aria-pressed={activePlan === option.id}
                    onClick={() => setActivePlan(option.id)}
                  >
                    {option.name}
                  </button>
                ))}
              </div>
            </div>

            <p className="plan-name">{plan.name}</p>
            <p className="plan-price">
              <span className="price-lead is-placeholder">Starting at</span>
              <span className="price-figure">{plan.price}</span>
              <span className="price-unit">{plan.unit}</span>
            </p>
            <p className="plan-copy">{plan.copy}</p>
            <a
              className="btn btn-primary btn-block"
              href={contact.schedulingHref}
              target="_blank"
              rel="noopener noreferrer"
            >
              Get Started
            </a>
            <div className="price-card-footer">
              <p className="includes-label">Included in {plan.name}:</p>
              <CheckList items={plan.items} />
              {plan.note && <p className="fine-print">{plan.note}</p>}
            </div>
          </article>
        </div>
      </div>
    </section>
  );
}
